export default {
  error: {
    error_occured: "Une erreur est survenue",
    not_found: "La ressource demandée est introuvable.",
    reload_page: "Rafraichir la page",
    back: "Revenir en arrière",
    message: {
      profile_load_failed:
        "Impossible de charger votre profil, certaines informations peuvent être masquées. Veuillez rafraîchir la page.",
      not_found: "La page que vous avez demandée n'a pas été trouvée !",
      unavailable: "Service non disponible !",
      not_authorized_title: "Accès interdit",
      not_authorized: "Vous n'avez pas les autorisations requises",
      file_not_authorized: "Vous n'êtes pas autorisé à télécharger un fichier",
      unauthenticated: "Vous devez vous authentifier pour accéder à cette page",
      usurpation_error: "Vous incarnez un compte qui n'a pas accès à cet espace, veuillez désincarner cet utilisateur",
      usurpation_restore_lost:
        "Vous avez quitté le compte incarné. Merci de vous reconnecter pour retrouver votre session.",
      session_lost: "Votre session a expiré, merci de vous reconnecter",
    },
    go_back_to_home: "Revenir à l'accueil",
    support_message:
      "Une erreur est survenue lors de l’opération. Nos équipes sont mobilisées pour résoudre le problème. Merci de votre compréhension.",
    login_attempts:
      "Il vous reste {attempts} essais. Au-delà, votre accès sera suspendu pendant 5 minutes par mesure de sécurité.",
    login_blocked:
      "Votre compte est temporairement bloqué suite à plusieurs tentatives infructueuses. Veuillez patienter 5 minutes avant de réessayer.",
    sso_user_not_found: "Aucun compte Studea ne correspond à cet utilisateur. Veuillez contacter votre administrateur.",
    sso_link_expired:
      "Votre lien de connexion n'est plus valide. Veuillez vous reconnecter depuis votre espace habituel.",
  },
  warning: {
    title: "Attention : ",
  },
};
